import { Box, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

export const StyledText = styled(Inscription)`
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
`;

export const AccountWrapper = styled(Box)`
  > div:not(:last-child) {
    position: relative;
    margin-bottom: ${({ theme }) => theme.spacings.spacing24};
    &:after {
      content: '';
      position: absolute;
      bottom: -12.5px;
      left: 0;
      width: 100%;
      height: 1px;
      background: ${({ theme }) => theme.colors.border1};
    }
  }
`;

export const RowItemWrapper = styled(Box)`
  > div:not(:first-child) {
    margin-left: ${({ theme }) => theme.spacings.spacing16};
  }
`;

export const HoveredIcon = styled(Box)`
  &:hover {
    cursor: pointer;
    svg {
      fill: ${({ theme }) => theme.colors.accentActive};
    }
  }
`;

export const RowWrapper = styled(Box)`
  > div:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.spacing8};
  }
`;

export const ButtonsList = styled(Box)`
  > div:not(:first-child) {
    margin-left: ${({ theme }) => theme.spacings.spacing12};
  }
`;
